import { CruiseApi } from "../../Types/Generated/LogbookApi/CruiseApi"
import type { ICruiseResponse } from "../../Types/Generated/LogbookModel/Cruise"
import { IStoredCalculationSource } from "../../Types/Generated/LogbookModel/StoredCalculation"
import { entity } from "./Connection"
import {
  applyCalculationResults,
  calculationFolds,
  calculationProjectionFields,
  cruiseNotableFolds,
  preserveCalculationProjection,
} from "./Folds"

export function cruiseResponseEntity(response: ICruiseResponse, previous?: ICruiseResponse["cruise"]) {
  return preserveCalculationProjection(applyCalculationResults(
    [response.cruise],
    response.calculation ? [response.calculation] : [],
    response.calculationV2 ? [response.calculationV2] : [],
  )[0], previous);
}

// CruiseView's single-Cruise slice (#1621, tracker #665): the typed get request
// carries the Cruise plus its calculation, notes and attachments.
export const CruiseEntity = entity("Cruise", {
  preserveLive: calculationProjectionFields,
  fetch: (client, ids) => {
    const { shipId, cruiseId } = ids;
    if (shipId === undefined) {
      return Promise.reject(new Error("Cruise fetch requires shipId"));
    }
    if (cruiseId === undefined) {
      return new CruiseApi(client).cruises.list({ params: { shipId } }).call().then((response) => ({
        entities: {
          Cruise: applyCalculationResults(
            response.cruises ?? [],
            response.calculations ?? [],
            response.calculationsV2 ?? [],
          ),
          Note: response.notes ?? [],
          NoteAttachment: response.attachments ?? [],
          DataRecord: response.dataRecords ?? [],
        },
        authoritative: { Cruise: { shipId } },
      }));
    }
    return new CruiseApi(client).cruises.get({ params: { shipId, cruiseId } }).call().then((response) => ({
      entities: {
        Cruise: [cruiseResponseEntity(response)],
        Note: response.notes ?? [],
        NoteAttachment: response.attachments ?? [],
        DataRecord: response.dataRecords ?? [],
      },
    }));
  },
  folds: {
    ...calculationFolds(IStoredCalculationSource.cruise),
    ...cruiseNotableFolds,
  },
});
